import "./contacts.css";
import BackBtn from "./Shared/BackBtn";
import CallIcon from "@mui/icons-material/Call";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import backend from "../../../../../../../api";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import { useSnackbar } from "notistack";
import { motion, easeOut } from "framer-motion";

export default function ContactsScreen() {
  const { user } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const contacts = user?.emergencyContacts || [];
  const [confirmDelete, setConfirmDelete] = useState(null);

  const deleteContact = async (index) => {
    try {
      const arr = [...(user?.emergencyContacts || [])].filter((_, i) => i !== index);
      const { data } = await backend.put(`/api/user/${user._id}`, { emergencyContacts: arr });
      dispatch(setUserData({ ...user, ...data.data }));
      enqueueSnackbar("Emergency contact deleted!", { variant: "success" });
      setConfirmDelete(null);
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.message || "Error deleting contact", { variant: "error" });
    }
  };

  return (
    <motion.div
      className="pf-wrap"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: easeOut }}
    >
      <BackBtn />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="pf-modal-title" style={{ textAlign: "left" }}>
          Emergency Contacts
        </h2>
        <Button
          className="pf-add-mini"
          onClick={() => nav("/settings/profile/emergency-contact/add")}
          startIcon={<AddIcon fontSize="14" />}
        >
          Add
        </Button>
      </div>

      <div className="pf-contacts-list">
        {contacts.length === 0 ? (
          <div className="pf-empty">
            No emergency contacts added yet.
          </div>
        ) : (
          contacts.map((c, i) => (
            <div key={i} className="pf-con-row">
              <img
                src={c.avatar || "/assets/images/profile.png"}
                alt="avatar"
                className="pf-con-avatar"
              />
              <div className="pf-con-info">
                <div style={{ fontWeight: 600, color: "var(--dark)" }}>{c.name}</div>
                <div style={{ color: "var(--subtle)" }}>{c.phone}</div>
              </div>
              <div className="pf-con-actions">
                <IconButton
                  onClick={() => window.open(`tel:${c.phone}`, "_self")}
                  aria-label="Call contact"
                >
                  <CallIcon fontSize="small" sx={{ color: 'black' }} />
                </IconButton>
                <IconButton
                  onClick={() => nav(`/settings/profile/emergency-contact/${i}`)}
                  aria-label="Edit contact"
                >
                  <EditIcon fontSize="small" sx={{ color: "var(--dark)" }} />
                </IconButton>
                <IconButton
                  onClick={() => setConfirmDelete(i)}
                  aria-label="Delete contact"
                >
                  <DeleteIcon fontSize="small" sx={{ color:"red" }} />
                </IconButton>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Confirm Delete Dialog */}
      <Dialog open={confirmDelete !== null} onClose={() => setConfirmDelete(null)}>
        <DialogTitle>Delete Emergency Contact?</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this emergency contact? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete(null)}>Cancel</Button>
          <Button
            onClick={() => deleteContact(confirmDelete)}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </motion.div>
  );
}